// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const diglett_alola: PokeData = {
  "id": 10105,
  "name": "diglett-alola",
  "height": 2,
  "weight": 10,
  "base_experience": 53,
  "types": [
    PokeType.GROUND,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "growl",
    "earthquake",
    "fissure",
    "dig",
    "agility",
    "fury-swipes",
    "slash",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "metal-claw",
    "astonish",
    "sucker-punch",
    "earth-power",
    "mud-bomb",
    "iron-head",
    "bulldoze"
  ],
  "moves": [
    "scratch",
    "growl",
    "earthquake",
    "fissure",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "metal-claw",
    "earth-power",
    "mud-bomb",
    "behemoth-bash",
    "bone-throw",
    "metal-rush"
  ],
  "evolution_chain": {
    "id": 21,
    "item": null,
    "species": [
      {
        "name": "diglett",
        "order": 55,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dugtrio-alola",
        "order": 56,
        "types": [
          PokeType.GROUND,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 50,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 48,
    "speed": 180,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
